// @ts-ignore
import pageTitleActions from "@cirrus/legacy/app-author/common/page-title-component/actions.js"

export function initTitle(title) {
  pageTitleActions.changeTitle({
    icon: "icon-todo-txt",
    title,
  })
}